const CLIENT_TIMEZONE = "America/Sao_Paulo"

export const formatToClientTimezone = (date) => {
  if (!date) return ""

  const parsed = new Date(date)
  if (Number.isNaN(parsed.getTime())) return ""

  return new Intl.DateTimeFormat("pt-BR", {
    timeZone: CLIENT_TIMEZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(parsed)
}
